import React, {useRef} from "react";
import FinderModeComponent from "./FinderMode";
import SearchMode from "./SearchMode";
import SearchModeTabs from "./SearchModeTabs";

const GeneralFilters = (props) =>  {
  const finderRef = useRef(null);
  return (
    <div className="product-finder-forms">
      <FinderModeComponent ref={finderRef} strings={props.strings} redirectMode={props.redirectMode} />
      <SearchMode finderRef={finderRef} strings={props.strings} redirectMode={props.redirectMode} />
      <SearchModeTabs strings={props.strings} />
    </div>
  );
}

export default GeneralFilters
